module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz8/7/Ef//EP3+Ef3+Evv9E/b6FYaGhmk9ADUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAACH5BAEHABsALAAAAAAgACAAAAXA4CaO5KadaKoBZeuamiDP8/neYkzvAqLhLh1v9wOWhMOa8VhTnWTFZU6gkVicz6g0psJcUlTpKIvlapeoJNUmhmXUGsrZeLrAr23YA84WP9VreU8GfIIaDXASc0AnDHByYgd6cF8bkkYHBxoTOgUFNAUomVKab4Anl1tcCRARCgsLGBaBbWZldos4OhpfKRSmuTdIFA4OFBQ0wS9IcIJqnlDOSdBhtc+f1X4j2DRjeRsVIoQznjnfIuFDJudjZUAhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadS_S4.gif
// module id = v6Dp
// module chunks = 44